/*globals $, ajaxUrl, siteRoot, FB */

$(document).ready(function () {
    "use strict";

    if ($("#socialDetailDisplay").length !== 0) {
        $("footer").addClass("hide");

        $(window).scroll(function () {
            if (($(document).height() - $(window).height() - $("footer").height()) <= $(window).scrollTop() && SOCIAL.atEnd === false) {
                $("#socialLoading").removeClass("invisible");
                SOCIAL.scroll();
            }
        });  
    }

    // Login
    $("#facebookLoginBtn").on("click", function (e) {
        e.preventDefault();
        $(e.target).addClass("btn-loading");
        //SOCIAL.checkLoginState();
        FB.login(function (response) {
            SOCIAL.facebookLogin(response);
        },
        {scope: "email"});
    });
});

var SOCIAL = {

    firstPost: undefined,
    currentPost: undefined,
    atEnd: false,

    scroll: function () {
        "use strict";

        var posts = $("[data-social-item]"),
            nextPost = posts.last().data("social-item");
        
        if (!this.firstPost) {
            this.firstPost = posts.first().data("social-item");
        }
        
        if (nextPost === this.currentPost) {
            return;
        }
        this.currentPost = nextPost;

        $.ajax({
            type: "post",
            url: ajaxUrl,
            data: {
                "action": "load_social_detail",
                "first": this.firstPost,
                "current": this.currentPost
            },
            dataType: "html",
            success: function (result) {
                $("#socialLoading").addClass("invisible");

                if (result === "END") {
                    SOCIAL.atEnd = true;
                    $(".show-more").addClass("invisible");
                    $("footer").removeClass("hide");
                } else {
                    $("#socialDetailDisplay").append(result);
                }
            },
            error: function (result) {
                $("body").html(result.responseText);
            }
        });
    },
    
    share: function (platform) {
        "use strict";

        var share = $.ajax({
            type: "post",
            url: ajaxUrl,
            dataType: "json",
            data: {
                action: "add_share_entry",
                contest: 1,
                platform: platform,
                email: entryEmail
            }
        });

        share.done(function (result) {
            //console.log(result);
        });
    },
    
    facebookShare: function (e, url) {
        "use strict";
        
        if ($(e.target).hasClass("disabled")) {
            e.preventDefault();
            $(e.target).removeClass("shareBtn");
            return;
        }
        
        $(e.target).addClass("disabled");
        SOCIAL.share("facebook");

//        FB.ui({
//            method: 'share',
//            //display: 'popup',
//            href: url
//        }, function (response) {
//            $(e.target).addClass("disabled");
//            SOCIAL.share("facebook");
//        });
    },

    twitterShare: function (e) {
        "use strict";
        
        if ($(e.target).hasClass("disabled")) {
            e.preventDefault();
            $(e.target).removeClass("shareBtn");
            return;
        }
        $(e.target).addClass("disabled");
        SOCIAL.share("twitter");
    },

    checkLoginState: function () {
        "use strict";
        
        FB.getLoginStatus(function (response) {
            SOCIAL.facebookLogin(response);
        });
    },

    facebookLogin: function (state) {
        "use strict";
        
        if (state.status !== "connected") {
            console.log("NOT CONNECTED");
            return;
        }

        FB.api("/me?fields=name,email", function (response) {
            //console.log(response);
            $.ajax({
                type: "post",
                url: ajaxUrl,
                dataType: "json",
                data: {
                    action: "facebook_login",
                    userid: response.id,
                    email: response.email,
                    name: response.name
                },
                success: function (result) {
                    //console.log(result);
                    window.location = siteRoot + "login?login=" + result;
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.log(errorThrown);
                }
            });
        });
    }
};